export function getFileOpenUrl(id) {
  return `https://drive.google.com/open?id=${id}`;
}

export function getFileRawUrl(id) {
  return `https://drive.google.com/a/praece.com/uc?id=${id}`;
}

export function getFolderOpenUrl(id) {
  return `https://drive.google.com/drive/folders/${id}`;
}

export function getFormUrl(id) {
  return `/api/form/${id}/view`;
}

export function getFormUrlAbsolute(id) {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  return `${protocol}//${hostname}/api/form/${id}/view`;
}

export default { getFileRawUrl, getFileOpenUrl, getFolderOpenUrl };
